import { Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export const mobileBreakpoint: number = parseInt(
  getComputedStyle(document.documentElement).getPropertyValue('--sm-size'),
);

export function isMobile(): boolean {
  return window.innerWidth <= mobileBreakpoint;
}

export function isMobile$(): Observable<boolean> {
  return fromEvent(window, 'resize').pipe(
    startWith(null),
    map(() => isMobile()),
  );
}

export function isMobileSignal(): Signal<boolean> {
  return toSignal(isMobile$(), { initialValue: isMobile() });
}
